import React, { useEffect, useState } from "react";
import {
  WETHX_TOKEN_ADDRESS,
  WETH_TOKEN_ADDRESS,
  POTION_DAO_STAKING_ADDRESS,
  PTN_TOKEN_ADDRESS,
  UNISWAP_ROUTER_ADDRESS,
  BNB_ORACLE,
} from "../../../Config/index";
import POTION_DAO_STAKING_ABI from "../../../Config/POTION_DAO_STAKING_ABI.json";
import IUniswapv2Pair from "../../../Config/IUniswapv2Pair.json";
import BNBORACLEABI from "../../../Config/BNBORACLE.json";

import { useAccount, useBalance, useContractRead } from "wagmi";
import { useConnectModal } from "@rainbow-me/rainbowkit";
import useCustomContractRead from "../../../Hooks/useCustomContractRead";
import convertWeiToEther from "../../../Utils/convertWeiToEther";
import useCustomContractWrite from "../../../Hooks/useCustomContractWrite";
import convertEtherToWei from "../../../Utils/convertEtherToWei";
import Loader from "../../Loader/Loader";

import { useNavigate } from "react-router-dom";

import style from "./dashboard.module.css";
import { formatNumber } from "../../common/FormateNum";
import { ethers } from "ethers";
import { NewFooter } from "../../NewFooter";
// import { NewFooter } from "../../NewFooter";

export default function Dashboard() {
  let { address, isConnected } = useAccount();
  // address = "0x09891866d01910E9Ee91710d335808464750Cb3D"
  const navigate = useNavigate();
  const [totalClaimableRewards, setTotalClaimableRewards] = useState("0");
  const [totalClaimableRewardsBNB, setTotalClaimableRewardsBNB] = useState("0");
  const [totalEarlyClaimableRewards, setTotalEarlyClaimableRewards] =
    useState("0");
  const [earlyPenalty, setearlyPenalty] = useState("0");
  const [unclaimedVesting, setunclaimedVesting] = useState("0");


  // address = "0x09891866d01910E9Ee91710d335808464750Cb3D";

  let alienPrice = 0;
  const { data: _alienPrice } = useCustomContractRead({
    Adrress: BNB_ORACLE,
    Abi: BNBORACLEABI,
    FuncName: "latestAnswer",
    // onSuccess:(data)=>{
    //   alienPrice = ethers.utils.formatUnits(data, 8);
    // }
  });
  alienPrice = _alienPrice ? ethers.utils.formatUnits(_alienPrice, 8) : 1;

  const [potionPrice, setPotionPrice] = useState(0);
  const { data: getAmountOutFoMinati } = useCustomContractRead({
    Adrress: "0xA976a4ba5076f1264e0f8fFB5b9ff4aC9Fd615fa",
    Abi: IUniswapv2Pair,
    FuncName: "getReserves",
    onSuccess: (data) => {
      // //console.log("rate", data);
      // let _ptn = Number(data[0]);
      // let _weth = Number(data?.[1]) * Number(alienPrice);
      // let _price = parseFloat(_weth / _ptn).toFixed(9);
      // setPotionPrice(_price);
    },
  });
  useEffect(() => {
    if (getAmountOutFoMinati && alienPrice) {
      let _ptn = Number(getAmountOutFoMinati[1]);
      let _weth = Number(getAmountOutFoMinati?.[0]) * Number(alienPrice);
      let _price = parseFloat(_weth / _ptn).toFixed(9);
      if (!Number(_price)) {
        setPotionPrice(0);
      } else {
        setPotionPrice(_price);
      }
      // console.log("pricerate", _ptn,_weth,_price.toNumber(), alienPrice);
    }
  }, [getAmountOutFoMinati, alienPrice]);

  const { data: claimableRewards } = useCustomContractRead({
    Adrress: POTION_DAO_STAKING_ADDRESS,
    Abi: POTION_DAO_STAKING_ABI,
    FuncName: "claimableRewards",
    Args: [address],
    isEnabled: address !== undefined,
    onSuccess: (data) => {
      let total1 = convertWeiToEther?.(data?.[0]?.amount);
      let total2 = convertWeiToEther?.(data?.[1]?.amount);

      setTotalClaimableRewards?.(total1);
      setTotalClaimableRewardsBNB?.(total2);
    },
  });

  useEffect(() => {
    if (claimableRewards) {
      let total1 = convertWeiToEther?.(claimableRewards?.[0]?.amount);
      let total2 = convertWeiToEther?.(claimableRewards?.[1]?.amount);

      setTotalClaimableRewards?.(total1);
      setTotalClaimableRewardsBNB?.(total2);
    }
  }, [claimableRewards]);

  const { data: _withdrawablebalance } = useCustomContractRead({
    Adrress: POTION_DAO_STAKING_ADDRESS,
    Abi: POTION_DAO_STAKING_ABI,
    FuncName: "withdrawableBalance",
    Args: [address],
    isEnabled: address !== undefined,
    onSuccess: (data) => {
      setTotalEarlyClaimableRewards(convertWeiToEther?.(data?.[0]?.toString()));
      setearlyPenalty(convertWeiToEther?.(data?.[1]?.toString()));
    },
  });

  useEffect(() => {
    if (_withdrawablebalance) {
      setTotalEarlyClaimableRewards(
        convertWeiToEther?.(_withdrawablebalance?.[0]?.toString())
      );
      setearlyPenalty(
        convertWeiToEther?.(_withdrawablebalance?.[1]?.toString())
      );
    }
  }, [_withdrawablebalance]);

  const {
    executeWrite: getRewardContract,
    isLoading: isLoadinggetReward,
    isSuccess: isSuccessgetReward,
    isError: isErrorgetReward,
    error: errorgetReward,
    txHash: getRewardWaitForTransaction,
  } = useCustomContractWrite({
    address: POTION_DAO_STAKING_ADDRESS,
    abi: POTION_DAO_STAKING_ABI,
    functionName: "getReward",
    isEnabled:
      address !== undefined &&
      (parseFloat?.(totalClaimableRewards) > 0 ||
        parseFloat?.(totalClaimableRewardsBNB) > 0),
  });

  const { data: earnedBalances } = useCustomContractRead({
    Adrress: POTION_DAO_STAKING_ADDRESS,
    Abi: POTION_DAO_STAKING_ABI,
    FuncName: "earnedBalances",
    Args: [address],
    isEnabled: address !== undefined,
    onSuccess: (data) => {
      // setTotalEarlyClaimableRewards(
      //   parseFloat?.(totalClaimableRewards) +
      //     parseFloat?.(convertWeiToEther?.(data?.total?.toString()))
      // );
    },
  });


  const { data: balanceInfo } = useCustomContractRead({
    Adrress: POTION_DAO_STAKING_ADDRESS,
    Abi: POTION_DAO_STAKING_ABI,
    FuncName: "getBalanceInfo",
    Args: [address],
    isEnabled: address !== undefined,
    onSuccess: (data) => {
      // setTotalEarlyClaimableRewards(
      //   parseFloat?.(totalClaimableRewards) +
      //     parseFloat?.(convertWeiToEther?.(data?.total?.toString()))
      // );
    },
  });

  // console.log("balanceInfo", balanceInfo);
  
  
  useEffect(() => {

    if (earnedBalances && balanceInfo && balanceInfo?.earned && earnedBalances?.[0]?.toString()) {
        setunclaimedVesting(convertWeiToEther(balanceInfo?.earned) - convertWeiToEther(earnedBalances?.[0]?.toString()))
    }

  }, [earnedBalances,address,balanceInfo])




  const { data: lockedBalances } = useCustomContractRead({
    Adrress: POTION_DAO_STAKING_ADDRESS,
    Abi: POTION_DAO_STAKING_ABI,
    FuncName: "lockedBalances",
    Args: [address],
    isEnabled: address !== undefined,
    // onSuccess:(data)=>{
    //   console.log(data?.total?.toString());
    // }
  });

  const {
    executeWrite: emergencyWithdrawContract,
    isLoading: isLoadingemergencyWithdraw,
    isSuccess: isSuccessemergencyWithdraw,
    isError: isErroremergencyWithdraw,
    error: erroremergencyWithdraw,
    txHash: emergencyWithdrawWaitForTransaction,
  } = useCustomContractWrite({
    address: POTION_DAO_STAKING_ADDRESS,
    abi: POTION_DAO_STAKING_ABI,
    functionName: "emergencyWithdraw",
    isEnabled:
      address !== undefined && parseFloat?.(totalEarlyClaimableRewards) > 0,
  });

  
  const {
    executeWrite: withdrawExpiredVestingsContract,
    isLoading: isLoadingwithdrawExpiredVestings,
    isSuccess: isSuccesswithdrawExpiredVestings,
    isError: isErrorwithdrawExpiredVestings,
    error: errorwithdrawExpiredVestings,
    txHash: withdrawExpiredVestingsWaitForTransaction,
  } = useCustomContractWrite({
    address: POTION_DAO_STAKING_ADDRESS,
    abi: POTION_DAO_STAKING_ABI,
    functionName: "withdrawExpiredVestings",
    isEnabled:
      address !== undefined && unclaimedVesting > 0,
  });


  const { data: totalStakedSupply } = useCustomContractRead({
    Adrress: POTION_DAO_STAKING_ADDRESS,
    Abi: POTION_DAO_STAKING_ABI,
    FuncName: "totalSupply",
    // onSuccess:(data)=>{
    //   console.log(data?.toString());
    // }
  });

  const { data: totalLockedSupply } = useCustomContractRead({
    Adrress: POTION_DAO_STAKING_ADDRESS,
    Abi: POTION_DAO_STAKING_ABI,
    FuncName: "lockedSupply",
    // onSuccess:(data)=>{
    //   console.log(data?.toString());
    // }
  });

  const lockedUSD = (
    parseFloat?.(convertWeiToEther?.(totalLockedSupply)).toFixed(2) *
    potionPrice
  ).toString();

  const stakedUSD = (
    parseFloat?.(convertWeiToEther?.(totalStakedSupply)).toFixed(2) *
    potionPrice
  ).toString();

  const [remainingTimes, setRemainingTimes] = useState([]);
  const [remainingTimesLocks, setRemainingTimesLocks] = useState([]);

  const calculateRemainingTime = (epochTime) => {
    const currentTime = Math.floor(Date.now() / 1000); // Get current time in seconds (epoch)
    const timeLeft = epochTime - currentTime; // Calculate remaining time

    if (timeLeft <= 0) return { days: 0, hours: 0, minutes: 0, seconds: 0 };

    const days = Math.floor(timeLeft / (60 * 60 * 24));
    const hours = Math.floor((timeLeft % (60 * 60 * 24)) / (60 * 60));
    const minutes = Math.floor((timeLeft % (60 * 60)) / 60);
    const seconds = Math.floor(timeLeft % 60);

    return { days, hours, minutes, seconds };
  };

  useEffect(() => {
    const interval = setInterval(() => {
      // const updatedRemainingTimes = earnedBalances?.[1]?.map(
      //   ([amount, epochTime]) => calculateRemainingTime(Number(epochTime))
      // );
      const updatedRemainingTimes = earnedBalances?.[1]?.map((item) =>
        calculateRemainingTime(Number(item.unlockTime))
      );

      setRemainingTimes(updatedRemainingTimes);
    }, 1000); // Update every second

    return () => clearInterval(interval); // Cleanup the interval on component unmount
  }, [earnedBalances]);

  useEffect(() => {
    const interval = setInterval(() => {
      // const updatedRemainingTimes = lockedBalances?.[3]?.map(
      //   ([amount, epochTime]) => calculateRemainingTime(Number(epochTime))
      // );
      const updatedRemainingTimes = lockedBalances?.[3]?.map((item) =>
        calculateRemainingTime(Number(item.unlockTime))
      );

      setRemainingTimesLocks(updatedRemainingTimes);
    }, 1000); // Update every second

    return () => clearInterval(interval); // Cleanup the interval on component unmount
  }, [lockedBalances]);

  return (
    <main className={style.dashboard}>
      <section className={`${style.dashboard_body} d-flex gap-3 p-5 pb-sm-0 `}>
        <div className={style.left + " col-7 d-flex flex-wrap gap-3"}>
          <div className={style.card1}>
            <div className="d-flex justify-content-between align-items-center">
              <h2>Total Staked</h2>
              <div className="tooltip-parent position-relative">
                <img src="/icons/info.svg" alt="" />
                <p className="info-tooltip position-absolute">
                  Total number of SHIELD staked by everyone using this protocol
                  in flexible staking
                </p>
              </div>
            </div>
            <div className="d-flex align-items-center gap-3 mt-5 justify-content-center">
              <div
                className={
                  style.imgdiv +
                  " d-flex justify-content-center align-items-center"
                }
              >
                <img src="/icons/logo.svg" alt="" />
              </div>
              <div className="d-flex align-items-end gap-3">
                <p className="mb-0">
                  {parseFloat?.(
                    convertWeiToEther?.(totalStakedSupply?.toString())
                  )?.toFixed(2)}{" "}
                </p>
                <span className="opacity-50">
                  ${parseFloat?.(stakedUSD).toFixed(3)}
                </span>
              </div>
            </div>
            <p
              className="text-center opacity-50 mb-5"
              style={{ fontSize: "14px" }}
            >
              Total SHiELD Staked
            </p>

            <button
              className="btn1 py-3 w-100"
              onClick={() => navigate("/stake")}
            >
              Stake More
            </button>
          </div>
          <div className={style.card1}>
            <div className="d-flex justify-content-between align-items-center">
              <h2>Total Locked</h2>
              <div className="tooltip-parent position-relative">
                <img src="/icons/info.svg" alt="" />
                <p className="info-tooltip position-absolute">
                  Total number of SHIELD locked by everyone using the protocol
                  in locked staking
                </p>
              </div>
            </div>
            <div className="d-flex align-items-center gap-3 mt-5 justify-content-center">
              <div
                className={
                  style.imgdiv +
                  " d-flex justify-content-center align-items-center"
                }
              >
                <img src="/icons/logo.svg" alt="" />
              </div>
              <div className="d-flex align-items-end gap-3">
                <p className="mb-0">
                  {" "}
                  {parseFloat?.(
                    convertWeiToEther?.(totalLockedSupply?.toString())
                  )?.toFixed(2)}{" "}
                </p>
                <span className="opacity-50">
                  ${parseFloat?.(lockedUSD).toFixed(3)}
                </span>
              </div>
            </div>
            <p
              className="text-center opacity-50 mb-5"
              style={{ fontSize: "14px" }}
            >
              Total SHiELD Locked
            </p>

            <button
              className="btn1 py-3 w-100"
              onClick={() => navigate("/lock")}
            >
              Lock More
            </button>
          </div>
          <div className={style.card2}>
            <div className="d-flex px-4 pb-0 pt-2 justify-content-between align-items-center">
              <h2>Vesting</h2>
              <div className="tooltip-parent position-relative">
                <img src="/icons/info.svg" alt="" />
                <p className="info-tooltip position-absolute">
                  Farm claimable rewards which are currently vested if you claim
                  from farm they will show here. all rewards claimed in one
                  epoch cycle will be vested through same cycle.
                </p>
              </div>
            </div>
            <div className={style.card_parent + " mt-3"}>
              {earnedBalances?.[1]?.length > 0 ? (
                earnedBalances?.[1].map((data, index) => (
                  <div
                    key={index}
                    className={
                      style.card +
                      " d-flex flex-wrap flex-xl-nowrap justify-content-between align-items-center"
                    }
                  >
                    <div className="d-flex gap-2 align-items-center">
                      <div
                        className={
                          style.imgdiv +
                          " d-flex justify-content-center align-items-center"
                        }
                      >
                        <img src="/icons/logo.svg" alt="" />
                      </div>
                      <p className="mb-0">
                        {parseFloat?.(
                          convertWeiToEther?.(data?.amount?.toString())
                        ).toFixed(2)}{" "}
                      </p>{" "}
                      {/* Replace with dynamic data */}
                    </div>
                    <div className="d-lg-none d-md-block d-sm-none d-xl-block">
                      <div className="d-flex justify-content-between mt-2 mt-sm-0 gap-md-5 gap-2 gap-lg-2 gap-xl-5">
                        <p className="mb-0 opacity-50">Claimable in</p>
                        <div className="d-flex gap-1">
                          <p className="mb-0">
                            {remainingTimes[index]?.days || 0}D
                          </p>
                          <p className="mb-0">
                            {remainingTimes[index]?.hours || 0}H
                          </p>
                          <p className="mb-0">
                            {remainingTimes[index]?.minutes || 0}M
                          </p>
                          <p className="mb-0">
                            {remainingTimes[index]?.seconds || 0}S
                          </p>
                        </div>
                      </div>
                      {/* <input
                        id="input_curve"
                        type="range"
                        value={data.claimPercentage}
                        style={{
                          background: `linear-gradient(to right, var(--main-color) ${
                            data.claimPercentage
                          }%, #E3DEDE ${100 - data.claimPercentage}%`,
                        }}
                        className="curve-slider"
                      /> */}
                    </div>
                    <div className="d-flex align-items-center gap-3">
                      <div className="tooltip-parent align-items-center d-flex gap-2 position-relative">
                        <img src="/icons/info.svg" alt="" />
                        <p
                          className="mb-0 opacity-50"
                          style={{ fontWeight: "300" }}
                        >
                          info
                        </p>
                        <p
                          className="info-tooltip left position-absolute"
                          style={{
                            bottom: 0,
                            left: 0,
                            transform: "translate(-120%, 50%)",
                          }}
                        >
                          tooltip
                        </p>
                      </div>
                    </div>
                    <div className="w-100 d-md-none d-none d-sm-block d-lg-block d-xl-none">
                      <div className="d-flex justify-content-between mt-2 gap-md-5 gap-2 gap-lg-2 gap-xl-5 ">
                        <p className="mb-0 opacity-50">Claimable in</p>
                        <div className="d-flex gap-1">
                          <p className="mb-0">
                            {remainingTimes[index]?.days || 0}D
                          </p>
                          <p className="mb-0">
                            {remainingTimes[index]?.hours || 0}H
                          </p>
                          <p className="mb-0">
                            {remainingTimes[index]?.minutes || 0}M
                          </p>
                          <p className="mb-0">
                            {remainingTimes[index]?.seconds || 0}S
                          </p>
                        </div>
                      </div>
                      {/* <input
          id="input_curve"
          type="range"
          value={data.claimPercentage}
          style={{
            background:
              `linear-gradient(to right, var(--main-color) ${data.claimPercentage}%, #E3DEDE ${(100 - data.claimPercentage)}%`,
          }}
          className="curve-slider"
        /> */}
                    </div>
                  </div>
                ))
              ) : (
                <div className="d-flex justify-content-center align-items-center h-100">
                  <p className="opacity-50 fs-5" style={{ fontWeight: "300" }}>
                    No Vestings Found
                  </p>
                </div>
              )}
            </div>
            {unclaimedVesting > 0 && <div className="d-flex px-4 pb-0 pt-2 justify-content-between align-items-center">
              <h2>Unclaimed Vesting Rewards</h2>
              <div className="tooltip-parent align-items-center d-flex gap-2 position-relative">
                <div>
                  <img src="/icons/logo.svg" alt="" />
                  { Number(unclaimedVesting)?.toFixed(2)}
                </div>
              </div>
              <button className="btn1 py-3 px-3" 
               disabled={
                address !== undefined &&
                (parseFloat?.(unclaimedVesting) > 0 ||
                  parseFloat?.(unclaimedVesting) > 0) &&
                !isLoadingwithdrawExpiredVestings
                  ? false
                  : true
              }
               onClick={async () => {
                  // console.log("h");
                  try {
                    await withdrawExpiredVestingsContract();
                  } catch (error) {
                    console.log(error);
                  }
                }}>Claim
                {isLoadingwithdrawExpiredVestings && ". . ."}
                </button>
            </div>}
          </div>

          <div className={style.card2}>
            <div className="d-flex px-4 pb-0 pt-2 justify-content-between align-items-center">
              <h2>Locked</h2>
              <div className="tooltip-parent position-relative">
                <img src="/icons/info.svg" alt="" />
                <p className="info-tooltip position-absolute">
                  Tokens which are locked their unlocking date.
                </p>
              </div>
            </div>
            <div className={style.card_parent + " mt-3"}>
              {lockedBalances?.[3]?.length > 0 ? (
                lockedBalances?.[3].map((data, index) => (
                  <div
                    key={index}
                    className={
                      style.card +
                      " d-flex flex-wrap flex-xl-nowrap justify-content-between align-items-center"
                    }
                  >
                    <div className="d-flex gap-2 align-items-center">
                      <div
                        className={
                          style.imgdiv +
                          " d-flex justify-content-center align-items-center"
                        }
                      >
                        <img src="/icons/logo.svg" alt="" />
                      </div>
                      <p className="mb-0">
                        {parseFloat?.(
                          convertWeiToEther?.(data?.amount?.toString())
                        ).toFixed(2)}{" "}
                      </p>{" "}
                      {/* Replace with dynamic data */}
                    </div>
                    <div className="d-lg-none d-md-block d-sm-none d-xl-block">
                      <div className="d-flex justify-content-between mt-2 mt-sm-0 gap-md-5 gap-2 gap-lg-2 gap-xl-5">
                        <p className="mb-0 opacity-50">Unlocks in</p>
                        <div className="d-flex gap-1">
                          <p className="mb-0">
                            {remainingTimesLocks[index]?.days || 0}D
                          </p>
                          <p className="mb-0">
                            {remainingTimesLocks[index]?.hours || 0}H
                          </p>
                          <p className="mb-0">
                            {remainingTimesLocks[index]?.minutes || 0}M
                          </p>
                          <p className="mb-0">
                            {remainingTimesLocks[index]?.seconds || 0}S
                          </p>
                        </div>
                      </div>
                      {/* <input
                        id="input_curve"
                        type="range"
                        value={data.claimPercentage}
                        style={{
                          background: `linear-gradient(to right, var(--main-color) ${
                            data.claimPercentage
                          }%, #E3DEDE ${100 - data.claimPercentage}%`,
                        }}
                        className="curve-slider"
                      /> */}
                    </div>
                    <div className="d-flex align-items-center gap-3">
                      <div className="tooltip-parent align-items-center d-flex gap-2 position-relative">
                        <img src="/icons/info.svg" alt="" />
                        <p
                          className="mb-0 opacity-50"
                          style={{ fontWeight: "300" }}
                        >
                          info
                        </p>
                        <p
                          className="info-tooltip left position-absolute"
                          style={{
                            bottom: 0,
                            left: 0,
                            transform: "translate(-120%, 50%)",
                          }}
                        >
                          tooltip
                        </p>
                      </div>
                    </div>
                    <div className="w-100 d-md-none d-none d-sm-block d-lg-block d-xl-none">
                      <div className="d-flex justify-content-between mt-2 gap-md-5 gap-2 gap-lg-2 gap-xl-5 ">
                        <p className="mb-0 opacity-50">Claimable in</p>
                        <div className="d-flex gap-1">
                          <p className="mb-0">
                            {remainingTimesLocks[index]?.days || 0}D
                          </p>
                          <p className="mb-0">
                            {remainingTimesLocks[index]?.hours || 0}H
                          </p>
                          <p className="mb-0">
                            {remainingTimesLocks[index]?.minutes || 0}M
                          </p>
                          <p className="mb-0">
                            {remainingTimesLocks[index]?.seconds || 0}S
                          </p>
                        </div>
                      </div>
                      {/* <input
          id="input_curve"
          type="range"
          value={data.claimPercentage}
          style={{
            background:
              `linear-gradient(to right, var(--main-color) ${data.claimPercentage}%, #E3DEDE ${(100 - data.claimPercentage)}%`,
          }}
          className="curve-slider"
        /> */}
                    </div>
                  </div>
                ))
              ) : (
                <div className="d-flex justify-content-center align-items-center h-100">
                  <p className="opacity-50 fs-5" style={{ fontWeight: "300" }}>
                    No Locks Found
                  </p>
                </div>
              )}
            </div>
            {(lockedBalances && lockedBalances?.unlockable) && <div className="d-flex px-4 pb-0 pt-2 justify-content-between align-items-center">
              <h2>Unlockable</h2>
              <div className="tooltip-parent align-items-center d-flex gap-2 position-relative">
                <div>
                  <img src="/icons/logo.svg" alt="" />
                  { Number(convertWeiToEther(lockedBalances?.unlockable))?.toFixed(2)}
                </div>
              </div>
            </div>}

          </div>

         

        </div>
        <div className={style.right}>
          <h2 className="mb-4">Claim your Rewards</h2>
          <div className={style.card + " mb-3"}>
            <div
              className={
                style.head +
                " d-flex flex-column flex-sm-row gap-2 justify-content-between align-items-center"
              }
            >
              <h3>Claimable Rewards</h3>
              <p className="mb-0 opacity-50 text-sm-end text-center">
                Includes SHiELD Locked and Staked
              </p>
            </div>
            <div className="d-flex mt-2 justify-content-between align-items-center gap-2">
              <div className="d-flex gap-2">
                <div
                  className={
                    style.imgdiv +
                    " d-flex justify-content-center align-items-center"
                  }
                >
                  <img src="/icons/logo.svg" alt="" />
                </div>
                <div className={style.cost + " d-flex align-items-end gap-2"}>
                  <p className="mb-0">
                    {formatNumber(
                      parseFloat?.(totalClaimableRewards).toFixed(2)
                    )}
                  </p>
                  {/* <span className="opacity-50">$24.78</span> */}
                </div>
              </div>
              <div className="d-flex gap-2">
                <div
                  className={
                    style.imgdiv +
                    " d-flex justify-content-center align-items-center"
                  }
                >
                  <img src="/icons/bnb.png" alt="" />
                </div>
                <div className={style.cost + " d-flex align-items-end gap-2"}>
                  <p className="mb-0">
                    {formatNumber(
                      parseFloat?.(totalClaimableRewardsBNB).toFixed(5)
                    )}
                  </p>
                  {/* <span className="opacity-50">$24.78</span> */}
                </div>
              </div>
              <button
                className="btn1 py-3 px-4"
                disabled={
                  address !== undefined &&
                  (parseFloat?.(totalClaimableRewards) > 0 ||
                    parseFloat?.(totalClaimableRewardsBNB) > 0) &&
                  !isLoadinggetReward
                    ? false
                    : true
                }
                onClick={async () => {
                  //  console.log("h");
                  try {
                    await getRewardContract();
                  } catch (error) {
                    console.log(error);
                  }
                }}
              >
                Claim
              </button>
            </div>
          </div>
          <div className={style.card + " mb-3"}>
            <div
              className={
                style.head +
                " d-flex flex-column flex-sm-row gap-2 justify-content-between align-items-center"
              }
            >
              <h3>SHiELD in Vesting</h3>
              <p className="mb-0 opacity-50 text-sm-end text-center">
                SHiELD can be claimed with 50% Penalty
              </p>
            </div>
            <div className="d-flex mt-2 justify-content-between align-items-center gap-2">
              <div className="d-flex gap-2">
                <div
                  className={
                    style.imgdiv +
                    " d-flex justify-content-center align-items-center"
                  }
                >
                  <img src="/icons/logo.svg" alt="" />
                </div>
                <div className={style.cost + " d-flex align-items-end gap-2"}>
                  <p className="mb-0">
                    {formatNumber(
                      (parseFloat?.(
                        convertWeiToEther?.(earnedBalances?.[0]?.toString())
                      )).toFixed(2)
                    )}
                  </p>
                  {/* <span className="opacity-50">$24.78</span> */}
                </div>
              </div>
              {/* <button className="btn1 py-3 px-4">Claim</button> */}
            </div>
          </div>
          <div className={style.card + " mb-3"}>
            <div
              className={
                style.head +
                " d-flex flex-column flex-sm-row gap-2 justify-content-between align-items-center"
              }
            >
              <h3>Claim All</h3>
              <p className="mb-0 opacity-50 text-sm-end text-center">
                With penalty if Applicable
              </p>
            </div>
            <div className="d-flex mt-2 justify-content-between align-items-center gap-2">
              <div className="d-flex gap-2">
                <div
                  className={
                    style.imgdiv +
                    " d-flex justify-content-center align-items-center"
                  }
                >
                  <img src="/icons/logo.svg" alt="" />
                </div>
                <div className={style.cost + " d-flex align-items-end gap-2"}>
                  <p className="mb-0">
                    {formatNumber(
                      (
                        parseFloat?.(totalEarlyClaimableRewards) +
                        parseFloat?.(totalClaimableRewards)
                      ).toFixed(0)
                    )}
                  </p>
                  {/* <span className="opacity-50">$24.78</span> */}
                </div>
              </div>
              <div className="d-flex gap-2">
                <div
                  className={
                    style.imgdiv +
                    " d-flex justify-content-center align-items-center"
                  }
                >
                  <img src="/icons/bnb.png" alt="" />
                </div>
                <div className={style.cost + " d-flex align-items-end gap-2"}>
                  <p className="mb-0">
                    {" "}
                    {formatNumber(
                      (parseFloat?.(totalClaimableRewardsBNB)).toFixed(2)
                    )}
                  </p>
                  {/* <span className="opacity-50">$24.78</span> */}
                </div>
              </div>

              <button
                className="btn1 py-3 px-4"
                disabled={
                  address !== undefined &&
                  parseFloat?.(
                    totalEarlyClaimableRewards + totalClaimableRewards
                  ) > 0 &&
                  !isLoadingemergencyWithdraw
                    ? false
                    : true
                }
                onClick={async () => {
                  // console.log("h");
                  try {
                    await emergencyWithdrawContract();
                  } catch (error) {
                    console.log(error);
                  }
                }}
              >
                Claim
                {isLoadingemergencyWithdraw && ". . ."}
              </button>
            </div>
          </div>
        </div>
      </section>
      <NewFooter />
    </main>
  );
}
